/*
 * Client-side stage router for the RONE funnel (offer / flavors / onetime).
 * All three stages render on one product template; this swaps which
 * [data-rone-stage] group is visible based on ?step= — no page reload.
 * Elements with no data-rone-stage (e.g. the announcement bar) always stay visible.
 */
if (!customElements.get('rone-stage-router')) {
  customElements.define(
    'rone-stage-router',
    class RoneStageRouter extends HTMLElement {
      connectedCallback() {
        if (window.roneStageRouterLoaded) return;
        window.roneStageRouterLoaded = true;

        // The one-time page is a separate purchase path from Subscribe &
        // Save — crossing into or out of it (by any route: an in-page link,
        // the browser back/forward button, or landing on the URL directly)
        // clears the cart so a pending one-time item never mixes with
        // subscription line items or vice versa.
        this.lastStage = null;
        this.isInitialApply = true;

        // These only mean anything on the flavors stage (chosen tier/plan
        // and the shopper's flavor picks) — clear them on every transition
        // so leaving and re-entering (or picking a different tier from the
        // offer stage) never leaks a stale selection into the new stage.
        // Anything else in the query string (view, utm_*, etc.) is left
        // untouched.
        this.STAGE_ONLY_PARAMS = ['quantity', 'plan', 'frequency', 'offerName', 'flavors'];

        this.handleClick = this.handleClick.bind(this);
        this.handlePopstate = this.handlePopstate.bind(this);

        document.addEventListener('click', this.handleClick);
        window.addEventListener('popstate', this.handlePopstate);

        this.applyStage(this.currentStage());
      }

      currentStage() {
        return new URLSearchParams(window.location.search).get('step') || 'offer';
      }

      // Structural lookup instead of a hardcoded section id — survives the
      // merchant re-adding/reordering this app block in the theme editor.
      // :has() isn't supported in every legacy browser; fail closed (leave
      // Loox alone) rather than throw if the selector itself is rejected.
      findLooxSection() {
        try {
          var widget = document.querySelector('.shopify-app-block:has(> .loox-widget)');
          return widget ? widget.closest('.shopify-section') : null;
        } catch (error) {
          return null;
        }
      }

      // Only the two direct offer <-> onetime transitions clear the cart:
      // landing on ?view=rone-offer (stage defaults to "offer") and then
      // going to ?step=onetime, or the reverse — hitting the onetime
      // page's own "Prefer to save more? Subscribe & Save" link back to
      // ?step=offer. Any other way of reaching/leaving the onetime stage
      // (a direct deep link, coming from/going to flavors, back-navigating
      // from checkout, etc.) leaves the cart alone, since that's not
      // necessarily a fresh start of the shopper's journey.
      clearCartIfCrossingOnetime(nextStage) {
        var enteringOnetimeFromOffer = nextStage === 'onetime' && this.lastStage === 'offer';
        var leavingOnetimeToOffer = nextStage === 'offer' && this.lastStage === 'onetime';
        if (!enteringOnetimeFromOffer && !leavingOnetimeToOffer) return;

        fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).catch(function () {});
      }

      applyStage(stage) {
      //  this.clearCartIfCrossingOnetime(stage);
        this.lastStage = stage;

        document.querySelectorAll('[data-rone-stage]').forEach(function (el) {
          el.classList.toggle('rone-stage--hidden', el.dataset.roneStage !== stage);
        });

        // The Loox reviews block renders as its own independent top-level
        // section (Shopify's generic "apps" section type), so it has no
        // data-rone-stage of its own and isn't covered by the toggle above.
        var loox = this.findLooxSection();
        if (loox) {
          if (this.isInitialApply && stage !== 'offer') {
            // Landing directly on a non-offer step (e.g. a shared
            // ?step=flavors link) — remove it outright before Loox's own
            // script gets a chance to run, instead of letting it spend
            // 3-5s loading its iframe only to be hidden by CSS afterward.
            loox.remove();
          } else {
            loox.classList.toggle('rone-stage--hidden', stage !== 'offer');
          }
        }
        this.isInitialApply = false;

        document.dispatchEvent(new CustomEvent('rone:stage-enter', { detail: { stage: stage } }));
      }

      goTo(stage, extraParams) {
        var params = new URLSearchParams(window.location.search);
        params.set('step', stage);
        this.STAGE_ONLY_PARAMS.forEach(function (key) {
          params.delete(key);
        });
        Object.keys(extraParams || {}).forEach(function (key) {
          params.set(key, extraParams[key]);
        });

        var url = window.location.pathname + '?' + params.toString();
        window.history.pushState({ roneStage: stage }, '', url);
        this.applyStage(stage);
        window.scrollTo(0, 0);
      }

      handleClick(event) {
        var link = event.target.closest('[data-rone-goto]');
        if (!link) return;

        event.preventDefault();
        var stage = link.dataset.roneGoto;
        var query = (link.getAttribute('href') || '').split('?')[1] || '';
        var linkParams = new URLSearchParams(query);
        var extra = {};
        linkParams.forEach(function (value, key) {
          if (key !== 'step') extra[key] = value;
        });

        this.goTo(stage, extra);
      }

      handlePopstate() {
        this.applyStage(this.currentStage());
      }
    }
  );
}









//another method to clear cart if qty amd frequency is changed on the offer page
/*
 * Client-side stage router for the RONE funnel (offer / flavors / onetime).
 * All three stages render on one product template; this swaps which
 * [data-rone-stage] group is visible based on ?step= — no page reload.
 * Elements with no data-rone-stage (e.g. the announcement bar) always stay visible.
 
if (!customElements.get('rone-stage-router')) {
  customElements.define(
    'rone-stage-router',
    class RoneStageRouter extends HTMLElement {
      connectedCallback() {
        if (window.roneStageRouterLoaded) return;
        window.roneStageRouterLoaded = true;

        // The one-time page is a separate purchase path from Subscribe &
        // Save — crossing into or out of it (by any route: an in-page link,
        // the browser back/forward button, or landing on the URL directly)
        // clears the cart so a pending one-time item never mixes with
        // subscription line items or vice versa.
        this.lastStage = null;
        this.isInitialApply = true;

        // These only mean anything on the flavors stage (chosen tier/plan
        // and the shopper's flavor picks) — clear them on every transition
        // so leaving and re-entering (or picking a different tier from the
        // offer stage) never leaks a stale selection into the new stage.
        // Anything else in the query string (view, utm_*, etc.) is left
        // untouched.
        this.STAGE_ONLY_PARAMS = ['quantity', 'plan', 'frequency', 'offerName', 'flavors'];

        this.handleClick = this.handleClick.bind(this);
        this.handlePopstate = this.handlePopstate.bind(this);

        document.addEventListener('click', this.handleClick);
        window.addEventListener('popstate', this.handlePopstate);

        this.applyStage(this.currentStage());
      }

      currentStage() {
        return new URLSearchParams(window.location.search).get('step') || 'offer';
      }

      // Structural lookup instead of a hardcoded section id — survives the
      // merchant re-adding/reordering this app block in the theme editor.
      // :has() isn't supported in every legacy browser; fail closed (leave
      // Loox alone) rather than throw if the selector itself is rejected.
      findLooxSection() {
        try {
          var widget = document.querySelector('.shopify-app-block:has(> .loox-widget)');
          return widget ? widget.closest('.shopify-section') : null;
        } catch (error) {
          return null;
        }
      }

      clearCart() {
        fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).catch(function () {});
      }

      clearCartIfCrossingOnetime(nextStage) {
        var enteringOnetime = nextStage === 'onetime' && this.lastStage !== 'onetime';
        var leavingOnetime = this.lastStage === 'onetime' && nextStage !== 'onetime';
        if (!enteringOnetime && !leavingOnetime) return;
        this.clearCart();
      }

      // A tier deep-link (e.g. from an ad or email) lands directly on
      // ?quantity=X&frequency=Y — clear the cart once for that entry so a
      // stale line item from an earlier visit never mixes with the tier
      // the shopper is now landing on. Gated on isInitialApply in
      // applyStage() so later in-session navigation never re-triggers it.
      clearCartIfLandingOnTier() {
        var params = new URLSearchParams(window.location.search);
        if (!params.has('quantity') || !params.has('frequency')) return;
        this.clearCart();
      }

      applyStage(stage) {
        this.clearCartIfCrossingOnetime(stage);
        if (this.isInitialApply) this.clearCartIfLandingOnTier();
        this.lastStage = stage;

        document.querySelectorAll('[data-rone-stage]').forEach(function (el) {
          el.classList.toggle('rone-stage--hidden', el.dataset.roneStage !== stage);
        });

        // The Loox reviews block renders as its own independent top-level
        // section (Shopify's generic "apps" section type), so it has no
        // data-rone-stage of its own and isn't covered by the toggle above.
        var loox = this.findLooxSection();
        if (loox) {
          if (this.isInitialApply && stage !== 'offer') {
            // Landing directly on a non-offer step (e.g. a shared
            // ?step=flavors link) — remove it outright before Loox's own
            // script gets a chance to run, instead of letting it spend
            // 3-5s loading its iframe only to be hidden by CSS afterward.
            loox.remove();
          } else {
            loox.classList.toggle('rone-stage--hidden', stage !== 'offer');
          }
        }
        this.isInitialApply = false;

        document.dispatchEvent(new CustomEvent('rone:stage-enter', { detail: { stage: stage } }));
      }

      goTo(stage, extraParams) {
        var params = new URLSearchParams(window.location.search);
        params.set('step', stage);
        this.STAGE_ONLY_PARAMS.forEach(function (key) {
          params.delete(key);
        });
        Object.keys(extraParams || {}).forEach(function (key) {
          params.set(key, extraParams[key]);
        });

        var url = window.location.pathname + '?' + params.toString();
        window.history.pushState({ roneStage: stage }, '', url);
        this.applyStage(stage);
        window.scrollTo(0, 0);
      }

      handleClick(event) {
        var link = event.target.closest('[data-rone-goto]');
        if (!link) return;

        event.preventDefault();
        var stage = link.dataset.roneGoto;
        var query = (link.getAttribute('href') || '').split('?')[1] || '';
        var linkParams = new URLSearchParams(query);
        var extra = {};
        linkParams.forEach(function (value, key) {
          if (key !== 'step') extra[key] = value;
        });

        this.goTo(stage, extra);
      }

      handlePopstate() {
        this.applyStage(this.currentStage());
      }
    }
  );
}
*/